import Translate from '~/client/shared/i18n/Translate';
import ToggleButton from './ToggleButton';
import ControlsChevronDown from '@/external/icons/ControlsChevronDown';
import ControlsChevronUp from '@/external/icons/ControlsChevronUp';

type Props = {
  item: SortOptions;
  current: SelectedSort;
  handleSortSelect: (item: SortOptions) => void;
};

const SortItem: FC<Props> = ({ item, current, handleSortSelect }) => {
  const selected = item === current.name;
  const desc = current.value === -1;
  return (
    <ToggleButton selected={selected} onClick={() => handleSortSelect(item)}>
      {selected &&
        (desc ? (
          <ControlsChevronDown className="m-2 stroke-[4px] text-moon-16" />
        ) : (
          <ControlsChevronUp className="m-2 stroke-[4px] text-moon-16" />
        ))}
      <span className="m-2 text-moon-14">
        <Translate id={`casino.menu_item_${item}_order`} />
      </span>
    </ToggleButton>
  );
};

export default SortItem;
